import * as classNames from 'classnames'
import * as React from 'react'
import { compose, pure } from 'recompose'

import * as styles from './LargeTitle.css'

// Color
export const ColorType = {
  ACCENT: styles.accent,
  BASE: styles.base,
  MODEST: styles.modest,
  WHITE: styles.white
}

// Font Size
export const SizeType = {
  LARGE: styles.large,
  MEDIUM: styles.medium,
  SMALL: styles.small,
  TINY: styles.tiny
}

interface LargeTitleProps {
  children: string
  size?: string
  color?: string
}

const LargeTitle: React.FunctionComponent<LargeTitleProps> = ({
  children,
  size = SizeType.MEDIUM,
  color = ColorType.BASE
}) => {
  const titleClass = classNames(styles.text, size, color)
  return <h1 className={titleClass}>{children}</h1>
}

export default compose<LargeTitleProps, LargeTitleProps>(pure)(LargeTitle)
